<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">


      <div 
        class="row form-group">

        <div class="col">
        </div>

        <div
          class="col-auto"
          v-show="invoiceUrl">
          <a v-show="false" href="#" v-on:click.prevent="onPDFClick" class="btn btn-rounded btn-primary btn-block-xs-only">
            Export PDF
          </a>
        </div>

        <div
          class="col-auto"
          v-show="invoiceUrl">
          <a href="#" v-on:click.prevent="onPrintClick" class="btn btn-rounded btn-primary btn-block-xs-only">
            Print
          </a>
        </div>
        
      </div>

      <iframe
        id="billFrame"
        style="width:100%;"
        frameBorder="0"
        v-show="invoiceUrl">
      </iframe>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

export default {
  name: "PageOR",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Official Receipt' },
      ],

      invoiceUrl : null,
      title: '',
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(this.$route.query.orID) {
      this.loadReceipt(this.$route.query.orID);
    } else if(this.$route.query.RefNo) {
      this.loadReceipt2(this.$route.query.RefNo);
    } else {
      this.$refs['pageFeedback'].setFeedbackError('Unable to load official receipt information.');
    }
  },
  methods: {
    loadReceipt(orID) {
      let feedbackItem = 'official receipt data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/receipt/' + orID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          
          let invoicePath;
          try {
            let invoice = response.data.find(k => helper.compareID(k.id, orID));
            invoicePath = invoice.path;
            this.title = helper.plORNum(invoice.orNum, invoice.carparkID);
          } catch(e) {
          }

          this.displayInvoice(invoicePath);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadReceipt2(refNo) {
      let feedbackItem = 'official receipt data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/receipt/?collectionID=' + refNo,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          
          let invoicePath;
          try {
            let invoice = response.data.find(k => helper.compareID(k.collectionID, refNo));
            invoicePath = invoice.path;
            this.title = helper.plORNum(invoice.orNum, invoice.carparkID);
          } catch(e) {
          }

          this.displayInvoice(invoicePath);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    displayInvoice(invoicePath) {
      if(invoicePath) {
        // invoicePath = '/api2/invoice_url/' + invoicePath.substring(invoicePath.lastIndexOf('/'));
        invoicePath = '/api2/proxy?url=' + invoicePath;
        this.invoiceUrl = invoicePath;

        $('#billFrame').on('load', function() {
          var iframeDocument = this.contentDocument || this.contentWindow.document;
          this.style.height = iframeDocument.body.offsetHeight + 10 + "px";

          var iframeContent = iframeDocument.body;
          var html = iframeDocument.body.innerHTML;
          iframeDocument.body.innerHTML = "";

          var div = iframeDocument.createElement("div");
          div.id = "print_area";
          iframeDocument.body.appendChild(div);

          $("#billFrame").contents().find("#print_area").append(html);
          // $("#billFrame").contents().find("th")
          //   .css({ 
          //     "border-bottom": "1px solid black", 
          //     "border-right": "1px solid black", 
          //     "border-top": "1px solid black", 
          //     "border-left": "1px solid black", 
          //   });

          let imageHeader = iframeDocument.getElementsByClassName("img_header");
          imageHeader[0].style.width = '800px';
          imageHeader[0].style.height = '56.6px';
          let imageFooter = iframeDocument.getElementsByClassName("img_footer");
          imageFooter[0].style.width = '800px';
          imageFooter[0].style.height = '120px';
        });

        document.getElementById('billFrame').src = invoicePath;
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Unable to load invoice information.');
      }
    },
    onPrintClick() {
      document.getElementById('billFrame').contentWindow.print();
    },
    onPDFClick() {
      var iframe = document.getElementById("billFrame");
      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      // var iframeContent = iframeDocument.getElementsByTagName('body')[0];
      var iframeContent = iframeDocument.getElementById("print_area");

      // var pdf = new jsPDF("p", "pt", "a4");
      // pdf.fromHTML(
      //   iframeContent2,
      //   10,
      //   10,
      //   {
      //     'width': 1000
      //   }
      // );
      // pdf.save(this.title + '.pdf')

      html2canvas(iframeContent, {
        imageTimeout: 5000,
        useCORS: true,
        background: "#fff"
      }).then(canvas => {
        var imgData = canvas.toDataURL("image/jpeg");
        var options = {
          orientation: "0",
          unit: "px",
          format: "a4"
        };

        var doc = new jsPDF(options, "", "", "");
        var contentWidth = doc.internal.pageSize.getWidth() - 40;
        var contentHeight = doc.internal.pageSize.getHeight() - 40;

        var image = new Image();
        image = Canvas2Image.convertToJPEG(canvas);
        image.onload = () => {
          var ratio = image.width / contentWidth;
          var cropHeight = contentHeight * ratio;
          var count = image.height / cropHeight;
          
          for (var i = 0; i <= count; i++) {
            if(i > 0) {
              doc.addPage();
            }

            var pageCanvas = canvas;
            pageCanvas.setAttribute("width", image.width);
            pageCanvas.setAttribute("height", cropHeight);
            var pageCtx = pageCanvas.getContext("2d");
            pageCtx.fillStyle = "white";
            pageCtx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

            pageCtx.drawImage(
              image,
              0,
              i * cropHeight,
              image.width,
              cropHeight,
              0,
              0,
              image.width,
              cropHeight,
            );
            var pageImage = new Image();
            pageImage = Canvas2Image.convertToJPEG(pageCanvas);
            var pageImageData = pageImage.src;
            doc.addImage(pageImageData, "jpeg", 20, 20, contentWidth, contentHeight);
          }

          doc.save(this.title + ".pdf");
        };
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PageOR.vue